import React from 'react';
import { FormHelperText } from '@mui/material';
import { StylesSurgirTextAreaField } from 'utils/StyleSurgirTextAreaField';


interface SurgirTextAreaProps {
  fullWidth: boolean;
  id?: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  label: string;
  variant: any;
  error: boolean;
  messageError: string;
  maxLength: number;
  isDisabled?: boolean
}

const SurgirTextArea: React.FC<SurgirTextAreaProps> = ({
  messageError,
  error,
  value,
  onChange,
  label,
  fullWidth,
  variant,
  maxLength,
  isDisabled,
  id
}) => {
  return (
    <>
      <StylesSurgirTextAreaField
        id={id}
        helperText={error ? messageError : ''}
        error={error}
        value={value}
        onChange={onChange}
        label={label}
        multiline
        rows={5}
        inputProps={{ maxLength }}
        fullWidth={fullWidth}
        variant={variant}
        disabled={isDisabled ?? false}
      />
      <FormHelperText style={{ textAlign: 'right', width: '100%' }}>{`${value.length}/${maxLength}`}</FormHelperText>
    </>
  );
};

export { SurgirTextArea };
